import {
	// loginUser,
	getVipUser
} from '@/api/moudles/user.js'
/**
 ** @description 登录、获取用户信息、退出登录、清除token逻辑
 */

const state = () => ({
	token: '',
	token_time: '',
	userInfo: {},
	// 非会员
	noVipPhone: '',
	userVip: '',
	// 消息计数
	noticeCount:0,
})

const getters = {
	token: (state) => state.token,
	USERINFO: (state) => state.userInfo
}
// 同步修改
const mutations = {
	/**
	 * @description 修改token
	 */
	SET_TOKEN(state, token) {
		state.token = token
	},
	/**
	 * @description 设置token时间
	 */
	SET_TOKEN_TIME(state, time) {
		state.token_time = time
	},
	/**
	 * @description 设置用户信息
	 */
	SET_USER_INFO(state, user) {
		state.userInfo = user
	},
	/**
	 * @description 非会员手机账号
	 */
	SET_NOVIP_PHONE(state, phone) {
		state.noVipPhone = phone
	},
	/**
	 * @description 会员状态
	 */
	SET_VIP_STATUS(state, status) {
		state.userVip = status
	},
	/**
	 * @description 修改消息计数
	 */
	SET_NOTICE_COUNT(state, count) {
		state.noticeCount = count
	},
	/**
	 * @description 重置账户
	 */
	RESET_INFO(state) {
		state.token = ''
		state.token_time = ''
		state.userInfo = {}
		state.noVipPhone = ''
		state.userVip = ''
		state.noticeCount = 0
		localStorage.removeItem('token')
		localStorage.removeItem('tokenTime')
		localStorage.removeItem('recommend')
	}
}
// 异步方法修改
const actions = {
	async GET_USERINFO({
		commit
	}) {
		await getVipUser({
			success: res => {
				if(res.data){
					commit('SET_USER_INFO', res.data)
				}
			}
		})
	}
}

export default {
	state,
	getters,
	mutations,
	actions
}